import React from "react";
import { Link } from "react-router-dom";
import Twitter from "../../Assets/Twitter.png";
import Insta from "../../Assets/Insta.png";
import Youtube from "../../Assets/Youtube.png";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-8">
      <div className="container mx-auto w-4/5 flex flex-col md:flex-row justify-between items-start border-t-2 border-gray-400 pt-20">
        <div className="text-center md:text-left w-full md:w-1/3 mb-6 md:mb-0">
          <span className="orbitron text-2xl text-blue-400 font-bold">
            Solace UNO
          </span>
          <p className="mt-2 mb-4">
            Join us and shape the future of young persons mental wellbeing
          </p>
          <div className="flex space-x-8 justify-center md:justify-start  ">
            {/* Social Media Icons */}
            <a
              href="https://x.com/?lang=en&mx=2"
              className="text-gray-400 hover:text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Twitter} alt="Twitter" className="" />
            </a>
            <a
              href="https://www.instagram.com/"
              className="text-gray-400 hover:text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Insta} alt="Instagram" className="" />
            </a>
            <a
              href="https://www.youtube.com/"
              className="text-gray-400 hover:text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Youtube} alt="YouTube" className="" />
            </a>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex flex-col md:flex-row w-full md:w-2/3 justify-between text-center md:text-left">
          {/* Quick Links */}
          <div className="mb-6 md:mb-0">
            <h2 className="text-xl font-semibold mb-4">Quick Link</h2>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="hover:underline">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:underline">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:underline">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Community Links */}
          <div>
            <h2 className="text-xl font-semibold mb-4">Community</h2>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="hover:underline">
                  How it works!
                </Link>
              </li>
              {/* <li>
                <Link to="/" className="hover:underline">
                  Blockchain
                </Link>
              </li> */}
              <li>
                <Link to="/" className="hover:underline">
                  Get in touch
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center mt-8 w-4/5">
        <p className="text-center md:text-left">
          Copyright © 2023 Solace Uno All Rights Reserved.
        </p>
        <div className="flex space-x-4 mt-4 md:mt-0">
          <Link to="/" className="hover:underline">
            Privacy Policy
          </Link>
          <Link to="/" className="hover:underline">
            Terms of Use
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
